import { render, staticRenderFns } from "./lotteryResult.vue?vue&type=template&id=61587d8a&"
import script from "./lotteryResult.vue?vue&type=script&lang=js&"
export * from "./lotteryResult.vue?vue&type=script&lang=js&"
import style0 from "./lotteryResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports